import { useTranslations } from '../../../../../../../../../hooks/useTranslations';
import { NameValueTuple } from '../../../../../../../../../interfaces/ui';
import {
  GraspColors,
  graspColorsValues,
} from '../../../../../../../../../helpers/colors';
import { useCallback, useMemo } from 'react';
import { IPieChartData } from '../../../../../../../../../interfaces/charts';

export const useGetDataColor = () => {
  const { attachPrefix, wrapWithIntl } = useTranslations(
    'Cases.CaseDetails.AwareCase.Squeezes'
  );

  const colorDefinition = useMemo((): NameValueTuple<string, string>[] => {
    return [
      {
        name: wrapWithIntl(attachPrefix('squeezes')),
        value: graspColorsValues[GraspColors.Ocean500],
      },
      {
        name: wrapWithIntl(attachPrefix('alarms')),
        value: graspColorsValues[GraspColors.Warm600],
      },
    ];
  }, [attachPrefix, wrapWithIntl]);

  return useCallback(
    (data: IPieChartData) => {
      const existingColorDefinition = colorDefinition.find(
        (p) => p.name === data.name
      );

      if (!existingColorDefinition) return '#000';
      return existingColorDefinition.value;
    },
    [colorDefinition]
  );
};
